import React from 'react';

import {
  Summarize,
  Dashboard,
  RateReview,
  BookmarkAdded,
  PictureAsPdf,
  HowToReg,
} from '@mui/icons-material';

export const menuItems = [
  {
    icon: <Dashboard />,
    title: 'Reports',
    slug: 'reports',
    url: 'reports',
    child: [
      {
        icon: <Dashboard />,
        title: 'Purchase Order',
        slug: 'purchase_order',
        url: 'report/puchase_order',
        type: 'modal',
      },
      {
        icon: <Dashboard />,
        title: '90-90-90 Report',
        slug: 'ninety_ninety_ninety_report',
        url: 'report/ninety-ninety-report',
      },
      {
        icon: <Dashboard />,
        title: 'CWP Plot',
        slug: 'cwp_plot',
        url: 'report/cwp_plot',
        type: 'modal',
      },
      {
        icon: <Dashboard />,
        title: 'DCR',
        slug: 'dcr',
        url: 'report/dcr',
        type: 'modal',
      },
    ],
  },
  {
    icon: <BookmarkAdded />,
    title: 'Approval List',
    slug: 'approvals',
    child: [
      {
        icon: <BookmarkAdded />,
        title: 'CWP Approval',
        url: 'approvals/cwp',
        slug: 'cwp_approvals',
      },
      {
        icon: <BookmarkAdded />,
        title: 'Target Update Approval',
        slug: 'target_maintenance',
        url: 'target-maintenance',
      },
    ],
  },
  {
    icon: <HowToReg />,
    title: 'CWP Maintenance',
    slug: 'cwp_maintenance',
    child: [
      {
        icon: <HowToReg />,
        title: 'CWP Deletion Request',
        slug: 'cwp-maintenance',
        url: 'cwp-maintenance',
      },
      {
        icon: <HowToReg />,
        title: 'Delete/Cancel CWP',
        url: 'cwp-maintenance-deletion-request',
        slug: 'cwp-maintenance-deletion-request',
      },
    ],
  },
  {
    icon: <RateReview />,
    title: 'DCR Review',
    slug: 'dcr_review',
    url: 'dcr-review',
    child: [
      {
        icon: <RateReview />,
        title: 'DCR Viewer',
        url: 'dcr-listing',
        slug: 'dcr_listing',
      },
    ],
  },
  {
    icon: <Summarize />,
    title: 'MD Report',
    slug: 'md_report',
    url: '/manager-dashboard',
  },
  {
    icon: <PictureAsPdf />,
    title: 'Marketing Materials',
    slug: 'marketing_materials',
    url: 'marketing-materials',
  },
];

export const adminMenuItems = [
  {
    icon: <Dashboard />,
    title: 'Reports',
    slug: 'reports',
    url: 'reports',
    child: [
      {
        icon: <Dashboard />,
        title: 'Purchase Order',
        slug: 'purchase_order',
        url: 'report/puchase_order',
        type: 'modal',
      },
      {
        icon: <Dashboard />,
        title: '90-90-90 Report',
        slug: 'ninety_ninety_ninety_report',
        url: 'report/ninety-ninety-report',
      },
      {
        icon: <Dashboard />,
        title: 'CWP Plot',
        slug: 'cwp_plot',
        url: 'report/cwp_plot',
        type: 'modal',
      },
      {
        icon: <Dashboard />,
        title: 'DCR',
        slug: 'dcr',
        url: 'report/dcr',
        type: 'modal',
      },
    ],
  },
  {
    icon: <BookmarkAdded />,
    title: 'Approval List',
    slug: 'approvals',
    child: [
      {
        icon: <BookmarkAdded />,
        title: 'CWP Approval',
        url: 'approvals/cwp',
        slug: 'cwp_approvals',
      },
      {
        icon: <BookmarkAdded />,
        title: 'Target Update Approval',
        slug: 'target_maintenance',
        url: 'target-maintenance',
      },
    ],
  },
  {
    icon: <HowToReg />,
    title: 'CWP Maintenance',
    slug: 'cwp_maintenance',
    child: [
      {
        icon: <HowToReg />,
        title: 'CWP Deletion Request',
        slug: 'cwp-maintenance',
        url: 'cwp-maintenance',
      },
      {
        icon: <HowToReg />,
        title: 'Delete/Cancel CWP',
        url: 'cwp-maintenance-deletion-request',
        slug: 'cwp-maintenance-deletion-request',
      },
    ],
  },
];
